import { useEffect } from "react";
import { http } from "@/lib/api";

// Counts a minute of study only when this tab is visible and the student did something in the last 2 minutes.
const IDLE_MS = 2 * 60 * 1000;

export function useActivityTracker(enabled) {
  useEffect(() => {
    if (!enabled) return undefined;
    let last = Date.now();
    const touch = () => { last = Date.now(); };
    const events = ["pointerdown", "keydown", "scroll", "touchstart", "mousemove"];
    events.forEach((e) => window.addEventListener(e, touch, { passive: true, capture: true }));
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
    const tick = () => {
      if (document.visibilityState === "visible" && Date.now() - last < IDLE_MS) http.post("/activity/ping", { tz }).catch(() => {});
    };
    const t = setInterval(tick, 60000);
    tick();
    return () => { clearInterval(t); events.forEach((e) => window.removeEventListener(e, touch, { capture: true })); };
  }, [enabled]);
}
